import * as React from "react";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {IUserInfo, UserTypeEnum} from "../../model/UserInfo.model";
import {withVerifyAccess} from "../common/withVerifyAccess";
import {ClientApi, IClient} from "../../api/ClientApi";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";
import {AdminEditClientComponent} from "./AdminEditClient.component";
import {AssociatedPlansTable} from "./AssociatedPlansTable.component";
import {useParams} from "react-router";
import {useNavigate} from "react-router-dom";
import {navigateTo} from "../../../navigateTo";
import {multipleApiRequesterWrapper} from "../common/MultipleApiRequesterWrapper";
import {adminClientsWithPlansPair, adminUserDetailsPair} from "../common/RequesterPairs";
import {ClientsAndPlans, IAssociatedPlan, IClientInfo} from "../../model/ClientsAndPlans.model";
import {getSuccessData} from "../common/commonStates";
import {IApplicationRootState} from "../../../applicationState";
export const AdminEditClientPage: React.FunctionComponent = () => {
    const adminClientInfoState: ClientsAndPlans = useSelector(
        (state: IApplicationRootState) => getSuccessData(state.adminState!.adminClientInfoState)!
    );
    const adminUsersInfoState: IUserInfo[] = useSelector(
        (state: IApplicationRootState) => getSuccessData(state.adminState!.adminUsersInfoState) ?? []
    );
    const [client, setClient] = useState<IClient | undefined>(undefined);

    const { clientIdParam } = useParams();
    const clientId = Number.parseInt(clientIdParam!, 10);

    const navigate = useNavigate();

    useEffect(() => {
        ClientApi.requestClient(clientId).then((response) => {
            setClient(response);
        });
    }, [clientIdParam]);

    const cancelEdit = () => {
        navigateTo("/admin-client-plan", navigate);
    };

    const getUserCountForPlan = (planId: number): number => {
        return adminUsersInfoState.filter(user => user.planIds.includes(planId)).length;
    };

    const getAssociatedPlans = (): IAssociatedPlan[] => {
        const clientInfo: IClientInfo | undefined = adminClientInfoState.get(clientId);
        if (!clientInfo || !clientInfo.plans) {
            return [];
        }
        return clientInfo.plans.valueSeq().toArray()
            .map(plan => ({
                ...plan,
                userCount: getUserCountForPlan(plan.id),
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
    };

    const renderLoader = () => {
        return (
            <div className="page-container new-common-styles admin-edit-client-page__container">
                <LoadingSpinner />
            </div>
        );
    };

    if (!client) {
        return renderLoader();
    }

    return (
        <div className="page-container new-common-styles admin-edit-client-page__container">
            <div className="admin-edit-client-page__card">
                <div className="admin-edit-client-page__header-section">
                    <h1 className="admin-edit-client-page__header">Edit Client</h1>
                    <h2 className="admin-edit-client-page__client-name">{client.name}</h2>
                </div>
                <div className="admin-edit-client-page__content">
                    <div className="admin-edit-client-page__form-section">
                        <AdminEditClientComponent
                            onCancel={cancelEdit}
                            client={client}
                        />
                    </div>
                    <div className="admin-edit-client-page__divider" aria-hidden="true" />
                    <div className="admin-edit-client-page__plans-section">
                        <AssociatedPlansTable plans={getAssociatedPlans()} />
                    </div>
                </div>
            </div>
        </div>
    );
};

const withRequester = multipleApiRequesterWrapper(AdminEditClientPage, [
    adminClientsWithPlansPair,
    adminUserDetailsPair,
]);

export default withVerifyAccess(withRequester, UserTypeEnum.ADMIN);
